const pathKeys = [
  'filePath',
  'file_path',
  'targetFile',
  'target_file',
  'filename',
  'path',
] as const;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function readPathFromPayload(payload: unknown): string {
  if (!isRecord(payload)) {
    return '';
  }

  for (const key of pathKeys) {
    const value = payload[key];

    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }

  return '';
}

export function isSkillReadToolCall({
  toolName,
  input,
  output,
}: {
  toolName: string | undefined;
  input: unknown;
  output: unknown;
}): { isSkillRead: boolean; targetPath: string } {
  const normalizedToolName = (toolName ?? '').replace(/_/g, '-').toLowerCase();
  const targetPath = readPathFromPayload(input) || readPathFromPayload(output);

  return {
    isSkillRead:
      normalizedToolName === 'read-file' && /\/skill\.md$/i.test(targetPath),
    targetPath,
  };
}
